// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__CKGX6","input":"Checkbox_input__1SvzE","inlineLabel":"Checkbox_inlineLabel__A_PkG","isActive":"Checkbox_isActive__2AMvg"};